/* Copyright (c) 2023 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum NFREvents {
    FAILURE_LOADING_ACTIONS_LIST = 'failureLoadingActionsList',
    FAILURE_LOADING_CHANNELS = 'failureLoadingChannels',
    FAILURE_LOADING_GUIDE_ROWS = 'failureLoadingGuideRows',
    FAILURE_LOADING_PREVIEW = 'failureLoadingPreview',
    FAILURE_LOADING_VOD_OTT_ACTION_DETAILS = 'failureLoadingVodOttActionDetails',
    FINISH_LOADING_ACTIONS_LIST = 'finishLoadingActionsList',
    FINISH_LOADING_CHANNELS = 'finishLoadingChannels',
    FINISH_LOADING_GUIDE = 'finishLoadingGuide',
    FINISH_LOADING_GUIDE_ROWS = 'finishLoadingGuideRows',
    FINISH_LOADING_PREVIEW = 'finishLoadingPreview',
    FINISH_LOADING_VOD_OTT_ACTION_DETAILS = 'finishLoadingVodOttActionDetails',
    START_LOADING_ACTIONS_LIST = 'startLoadingActionsList',
    START_LOADING_CHANNELS = 'startLoadingChannels',
    START_LOADING_GUIDE = 'startLoadingGuide',
    START_LOADING_GUIDE_ROWS = 'startLoadingGuideRows',
    START_LOADING_PREVIEW = 'startLoadingPreview',
    START_LOADING_VOD_OTT_ACTION_DETAILS = 'startLoadingVodOttActionDetails',
}
